import { forwardRef, Children, cloneElement, useState } from "react";
import Flex from "../flex";
import { isFunction, isDefined } from "../../utils/type-util";
import Content from "./content";
import Header from "./header";
import Footer from "./footer";
import Sider, { SiderContext } from "./sider";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getInitialSiderState(children) {
  return children.filter(el => el.type === Sider).reduce((state, el) => {
    state[el.key] = isDefined(el.props.collapsed) ? el.props.collapsed : el.props.defaultCollapsed;
    return state;
  }, {});
}
function withCollapseSetter(setState) {
  return el => /*#__PURE__*/cloneElement(el, {
    onCollapse(collapsed) {
      if (isFunction(el.props.onCollapse)) {
        el.props.onCollapse(collapsed);
      }
      setState(state => ({
        ...state,
        [el.key]: collapsed
      }));
    }
  });
}
export const Layout = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    bg = "bg.body",
    color,
    children,
    ...rest
  } = _ref;
  const childrenArray = Children.toArray(children);
  const initialSiderState = getInitialSiderState(childrenArray);
  const [siderState, setSiderState] = useState(initialSiderState);
  const leftSiders = childrenArray.filter(el => el.type === Sider && el.props.align === "left").map(withCollapseSetter(setSiderState));
  const rightSiders = childrenArray.filter(el => el.type === Sider && el.props.align === "right").map(withCollapseSetter(setSiderState));
  const fixedHeaders = childrenArray.filter(el => el.type === Header && el.props.fixed);
  const otherElements = childrenArray.filter(el => el.type !== Sider && !(el.type === Header && el.props.fixed));
  const leftMargin = leftSiders.map(el => siderState[el.key] ? el.props.collapsedWidth : el.props.width).reduce((a, b) => a + b, 0);
  const rightMargin = rightSiders.map(el => siderState[el.key] ? el.props.collapsedWidth : el.props.width).reduce((a, b) => a + b, 0);
  return /*#__PURE__*/_jsxs(Flex, {
    ref: ref,
    as: "section",
    bg: bg,
    color: color,
    flexDirection: "column",
    minHeight: "100%",
    ...rest,
    ml: leftMargin,
    mr: rightMargin,
    children: [fixedHeaders.length > 0 && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: "2",
      ml: leftMargin,
      mr: rightMargin,
      children: fixedHeaders
    }), leftSiders.length > 0 && /*#__PURE__*/_jsx(Flex, {
      height: "100%",
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: "2",
      children: leftSiders
    }), rightSiders.length > 0 && /*#__PURE__*/_jsx(Flex, {
      height: "100%",
      position: "fixed",
      top: 0,
      right: 0,
      zIndex: "2",
      children: rightSiders
    }), otherElements]
  });
});
export default Object.assign(Layout, {
  Content,
  Header,
  Footer,
  Sider,
  SiderContext
});